module.exports = __webpack_public_path__ + "static/media/FEFRpeople.a279c3af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/FEFRpeople.svg
// module id = 210
// module chunks = 0